import { render, staticRenderFns } from "./Wellington.vue?vue&type=template&id=db57891c&"
import script from "./Wellington.vue?vue&type=script&lang=js&"
export * from "./Wellington.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports